import { createFileRoute } from '@tanstack/react-router';
import Battlefield from 'src/pages/Organization/Event/Mods/Battlefield';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/mods/$modId/battlefield',
)({
  component: Battlefield,
});
